import { render, staticRenderFns } from "./Playlist.vue?vue&type=template&id=3c037824&scoped=true"
import script from "./Playlist.vue?vue&type=script&lang=js"
export * from "./Playlist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c037824",
  null
  
)

export default component.exports